/* State Imports */

import StateInterface from "../state-interface";

/* Data before edit Default State Data */

export const data_before_edit: StateInterface["data_before_edit"] = "";
